(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nackt-visible-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nackt-visible-video')) {
    customElements.define('nackt-visible-video', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.video = this.querySelector('video');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.manual = false;
        this.onMotion = () => { this.manual = false; this.sync(); };
        this.motion.addEventListener('change', this.onMotion);
        document.addEventListener('visibilitychange', () => this.sync(), {signal:this.controller.signal});
        this.video.addEventListener('pause', () => this.removeAttribute('data-playing'), {signal:this.controller.signal});
        this.video.addEventListener('playing', () => this.setAttribute('data-playing',''), {signal:this.controller.signal});
        this.querySelector('button').addEventListener('click', () => { this.manual = true; this.visible = true; this.sync(); }, {signal:this.controller.signal});
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.1; if (!this.visible) this.manual = false; this.sync(); }, {threshold:0.1});
          this.observer.observe(this);
        }
      }
      sync() {
        if (this.visible && !document.hidden && (!this.motion.matches || this.manual)) {
          const source = this.video.querySelector('source[data-src]');
          if (source) { source.src = source.dataset.src; delete source.dataset.src; this.video.load(); }
          this.video.play()?.catch(() => this.removeAttribute('data-playing'));
        } else this.video.pause();
      }
      disconnectedCallback() {
        this.controller?.abort(); this.controller = null;
        this.observer?.disconnect(); this.motion?.removeEventListener('change',this.onMotion); this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
